import { useMemo } from "react";
import { useAppSelector } from "../../redux/hooks";

export const useContainer = (transportUnitId?: number) => {
    const transportUnits = useAppSelector((store) => store.catalog.transportUnits?.data);
    return useMemo(() => transportUnits.find((tu) => tu.id === transportUnitId)?.container ?? false, [transportUnits, transportUnitId]);
};
